import React from "react";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useAuthContext } from "./AuthContext";

const PageContentContext = createContext(null);

export const usePageContentContext = () => {
    const context = useContext(PageContentContext);

    if (!context) {
        throw new Error("usePageContentContext must be used within an ContentProvider");
    }
    return context;
};

export const PageContentProvider = ({ children }) => {
    const { zones } = useAuthContext();
    const pagesConfiguration = pagesConfigurationSetup;
    const [sideBarMenu, setSideBarMenu] = useState(null);
    const [withFilters, setWithFilters] = useState(null);
    const [currentPath, setCurrentPath] = useState(null);

    useEffect(() => {
        if (zones && zones.length > 0) {
            setCurrentPath(zones && zones.length > 0 ? '/' + zones[0] : '/home');
        }
    }, [zones]);

    useEffect(() => {
        const actualPageConfig = pagesConfiguration.filter((x) => x.path === currentPath);
        setSideBarMenu(actualPageConfig[0]?.subMenu);
        setWithFilters(actualPageConfig[0]?.filters);
    }, [currentPath]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const location = window.location.pathname;
            setCurrentPath(location);
        }
    }, [])

    const handlePagePathChange = (pathValue) => {
        setCurrentPath(pathValue);
    }

    const value = useMemo(() => {

        return {
            pagesConfiguration,
            sideBarMenu,
            withFilters,
            currentPath,
            handlePagePathChange
        };
    }, [pagesConfiguration, sideBarMenu, withFilters, currentPath]);

    return <PageContentContext.Provider value={value}>{children}</PageContentContext.Provider>
};

const pagesConfigurationSetup = [
    {
        tabName: "inicio",
        tabIcon: null,
        id: "home",
        path: "/home",
        filters: false,
    },
    {
        tabName: "map",
        tabIcon: null,
        id: "map",
        path: "/map",
        filters: true,
    },
    {
        tabName: "registry",
        tabIcon: null,
        id: "registry",
        path: "/registry",
        filters: false,
    },
    {
        tabName: "analytics",
        tabIcon: null,
        id: "analytics",
        path: "/analytics",
        filters: false,
    },
    {
        tabName: "events",
        tabIcon: null,
        id: "events",
        path: "/events",
        filters: false,
    },
    {
        tabName: "configurations",
        tabIcon: null,
        id: "configurations",
        path: "/configurations",
        filters: false,
    }
    // {
    //     tabName: "politicas",
    //     tabIcon: null,
    //     id: "policies",
    //     path: "/home/politics/CIRIS",
    //     subMenu: [{
    //         name: "Energia e Emissões",
    //         path: "/home/politics/CIRIS",
    //         submenus: null
    //     },
    //         // {
    //         //     name: "Certificado energético",
    //         //     path: "/home/politics/energeticCertficate",
    //         //     submenus: null
    //         // }
    //     ],
    //     filters: false
    // }
];